import script from "./MainLoadingScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainLoadingScreen.vue?vue&type=script&setup=true&lang=ts"

import "./MainLoadingScreen.vue?vue&type=style&index=0&id=8939224a&lang=scss"

const __exports__ = script;

export default __exports__